
export default class SearchFormOffers {

    constructor(){

        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }
        const body = document.querySelector( 'body' ) ;
        body.addEventListener( 'click', (e ) => { this.jobs_search_form__handler( e ); } );
    }

    jobs_search_form__handler( e ){

        // console.log( 'jobs_search_form__handler' );

        let target_dataset = e.target.dataset ;

        let this_button = e.target.closest('button') ;


        if( this_button != null ) {
            target_dataset = this_button.dataset;
        }


        if( 'search-form-offers-filter' === target_dataset.click ){

            e.preventDefault();
            e.stopPropagation();

            // - -

            if( ( 'reset' === target_dataset.behaviour ) ){

                let url = new URL(window.location);
                url = this.reset_url_filters( url );
                window.history.pushState({}, '', url );
            }
        }


        // - - - - - - - - - - - - - - - - - - - - - - - -


        if( 'search-form-offers-refresh' === target_dataset.click ){

            e.preventDefault();
            e.stopPropagation();

            // - -

            let url = new URL(window.location);
            let form_params = this.get_search_form_params( jQuery( e.target ).closest( 'form.search-form-offers' ) ) ;

            if( ( 'search' === target_dataset.behaviour ) || ( 'filter' === target_dataset.behaviour ) ){

                if( this.is_valid_form_params( form_params ) ){

                    url = this.update_url_search( url, form_params );
                    url = this.update_url_filters( url, form_params );

                    window.history.pushState({}, '', url );

                    // si le form n'est pas en mode alignfull -> on le passe.
                    // ca peut arrivr par ex avec le job-search

                    /*
                    const job_search = document.querySelector( '.wp-block-job-search' ) ;

                    if( ! job_search.classList.contains("alignfull") ){
                        try{ job_search.classList.remove("alignwide"); }catch (e){}
                        job_search.classList.add("alignfull");
                    }

                    const job_search__inner_container = job_search.querySelector( '.wp-block-job-search__inner-container' ) ;

                    if( ! job_search__inner_container.classList.contains("alignfull-with-mw") ){
                        job_search__inner_container.classList.add("alignfull-with-mw");
                    }

                    */


                    // - -
                }
            }
        }

        // - - - - - - - - - - - - - - - - - - - - - - - -
    }


    get_search_form_params( $form ){

        let results  = {} ;

        results.jobQ = {} ;

        results.jobQ.title    = $form.find( '#jobQ__title' ).val();
        results.jobQ.location = $form.find( '#jobQ__location' ).val();

        // - -

        results.jobF = {} ;

        let contracts = $form.find( '#job-filter--contracts input:checked' )  ;

        if( contracts.length > 0 ){ results.jobF.contracts = contracts.first().val() ; }
        else{ results.jobF.contracts = '' ; }


        // - -

        results.jobO = {} ;

        let order = $form.find( '#job-filter--order input:checked' )  ;

        if( order.length > 0 ){ results.jobO.order = order.first().val() ; }
        else{ results.jobO.order = '' ; }



        // - -

        results.jobF.sectors = [];

        let sectors = $form.find( '#job-filter--sectors input:checked' )  ;
        let sectors_list = [] ;
        if( sectors.length > 0 ){

            jQuery.each( sectors, function( index, value ){
                sectors_list.push( parseInt( jQuery( value ).val() )  ) ;
            });

            sectors_list.sort(function (a, b) { return a - b; });

            results.jobF.sectors = sectors_list ;
        }


        // - -

        results.jobF.regions = [];

        let regions = $form.find( '#job-filter--regions input:checked' )  ;
        let regions_list = [] ;
        if( regions.length > 0 ){

            jQuery.each( regions, function( index, value ){
                regions_list.push( jQuery.trim( jQuery( value ).val() ) ) ;
            });

            regions_list.sort(function (a, b) { return a - b; });

            results.jobF.regions = regions_list ;
        }


        return results ;
    }



    is_valid_form_params( params ){

        return true ;

        // disable location required
        // if( params.jobQ.title != '' ){ return true ; }

        // disable location required
        /*
		if( ( params.jobQ.title != '' ) && ( params.jobQ.location != '' ) ){
			return true ;
		}
		*/

        return false ;
    }




    update_url_search( url, params ){


        // basic :  title & location
        url.searchParams.set('jobQ[title]',    params.jobQ.title    );
        url.searchParams.set('jobQ[location]', params.jobQ.location );


        // pages & load more reset
        url.searchParams.set('jobP[pages]', '1' );
        try{ url.searchParams.delete('jobP[more]' );  }catch( error ){}

        return url ;

    }


    reset_url_filters( url ){


        for ( const [ param, value ] of url.searchParams.entries() ) {

            if( '' != param && null != param ){
                const regEx = new RegExp("^jobF\\[regions\\]\\[");
                const result = param.match( regEx ) ;

                if( null != result && result.length > 0 ){
                    try{ url.searchParams.delete(param );  }catch( error ){}
                }
            }

            if( '' != param && null != param ){
                const regEx = new RegExp("^jobF\\[sectors\\]\\[");
                const result = param.match( regEx ) ;

                if( null != result && result.length > 0 ){
                    try{ url.searchParams.delete(param );  }catch( error ){}
                }
            }

        }

        try{ url.searchParams.delete('jobF[contracts]' );  }catch( error ){}
        try{ url.searchParams.delete('jobF[regions][]' );  }catch( error ){}
        try{ url.searchParams.delete('jobF[sectors][]' );  }catch( error ){}

        return url ;

    }


    update_url_filters( url, params ){

        // order
        url.searchParams.set( 'jobO[order]', params.jobO.order );

        // contracts
        url.searchParams.set( 'jobF[contracts]', params.jobF.contracts );


        // sectors
        let sectors = params.jobF.sectors ;

        for ( const [ param, value ] of url.searchParams.entries() ) {

            if( '' != param && null != param ){
                const regEx = new RegExp("^jobF\\[sectors\\]\\[");
                const result = param.match( regEx ) ;

                if( null != result && result.length > 0 ){
                    try{ url.searchParams.delete(param );  }catch( error ){}
                }
            }
        }

        try{ url.searchParams.delete('jobF[sectors][]' );  }catch( error ){}

        if( sectors.length > 0 ){

            jQuery.each( sectors, function( index, value ){
                url.searchParams.append( 'jobF[sectors][]', value );
            });
        }


        // regions
        let regions = params.jobF.regions ;


        for ( const [ param, value ] of url.searchParams.entries() ) {

            if( '' != param && null != param ){
                const regEx = new RegExp("^jobF\\[regions\\]\\[");
                const result = param.match( regEx ) ;

                if( null != result && result.length > 0 ){
                    try{ url.searchParams.delete(param );  }catch( error ){}
                }
            }
        }

        try{ url.searchParams.delete('jobF[regions][]' );  }catch( error ){}

        if( regions.length > 0 ){

            jQuery.each( regions, function( index, value ){
                url.searchParams.append( 'jobF[regions][]', jQuery.trim( value ) );
            });
        }

        return url ;



    }



    // - - - - - - - - - - - - - - - - - - - - - - - -
}
